import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isCandidateDeleteAccountAllowed } from "../../constants/candidateDeleteTestAccounts";
import { deleteUserAccount } from "../../redux/actions/appActions";
import { ROUTE_MAIN } from "../../constants/routes";

type Props = {
  phoneNumber: string | undefined | null;
};

const CandidateDeleteAccount = ({ phoneNumber }: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ajaxCallsInProgress = useSelector((state: any) => state.ajaxCallsInProgress);
  const [open, setOpen] = useState(false);

  if (!isCandidateDeleteAccountAllowed(phoneNumber)) {
    return null;
  }

  const handleConfirm = () => {
    dispatch(
      deleteUserAccount(() => {
        setOpen(false);
        navigate(ROUTE_MAIN, { replace: true });
      })
    );
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Button
        variant="text"
        color="error"
        size="small"
        onClick={() => setOpen(true)}
        disabled={!!ajaxCallsInProgress}
        sx={{ textTransform: "none", p: 0, minWidth: 0, fontSize: "14px" }}
      >
        Delete account
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Delete account?</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary">
            This will permanently remove your candidate account and data. You will need to sign up again to use SeeVi.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setOpen(false)} color="inherit" disabled={!!ajaxCallsInProgress}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="error" variant="contained" disabled={!!ajaxCallsInProgress}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CandidateDeleteAccount;
